/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {NbWindowService} from '@nebular/theme';
import {BaseComponent, Document, DocumentPosition, FileService, InputFile} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {catchError, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {CrudEvent} from '../../interfaces/crud-event';

export interface DocumentFile {
  file: File;
}

@Component({
  selector: 'app-documents-uploader',
  templateUrl: './documents-uploader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DocumentsUploaderComponent extends BaseComponent implements OnChanges {

  @Input() model: any;
  @Input() uri: string;
  @Input() title = 'Документы';
  @Output() loadingEvent = new EventEmitter<CrudEvent>();
  uploadURI: string;
  showUploadForm = false;

  constructor(protected readonly windowService: NbWindowService,
              protected readonly fileService: FileService) {
    super();
  }

  ngOnChanges() {
    if (this.model) {
      this.uploadURI = this.uri + '/upload-document';
    }
  }

  onUpload(files: InputFile[]) {
    this.loadingEvent.emit(CrudEvent.UPLOADING);

    this.loading = true;
    this.compoApiService
      .postForm<DocumentFile, string>(this.uploadURI, {file: files[0].file})
      .pipe(
        take(1),
        catchError(error => this.handleError(error)),
        tap(resp => {
          this.loadingEvent.emit(CrudEvent.UPLOADING_DONE);

          this.model.documents.push(resp.data);
          this.cdr.detectChanges();
        }),
      ).subscribe();
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.model.documents, event.previousIndex, event.currentIndex);
    this.model.documents.forEach((value, idx) => value.pos = idx);
    this.updateDocumentsPositions();
  }

  updateDocumentsPositions() {
    const uri = this.uri + '/documents';
    const documentPositions: DocumentPosition[] = [];
    this.model.documents.forEach(document => documentPositions.push({id: document.id, pos: document.pos}));
    this.compoApiService.post(uri, documentPositions).pipe(takeUntil(this.unsubscribe)).subscribe(_ => {
    });
  }

  download(document: Document) {
    this.fileService
      .downloadUrl(this.fileService.getPublicDocumentUri(document.fileName))
      .subscribe(response => {
        FileService.saveAs(response, document.fileName);
      });
  }

  removeDialog(document: Document) {
    this.confirm(translations.confirmDelete + ' ' + translations.file.toLowerCase() + '?', new Observable(() => {
      this.removeDocument(document);
    }));
  }

  removeDocument(document: Document) {
    const uri = this.uri + '/document/' + document.id;
    this.compoApiService.delete<Document>(uri)
      .pipe(
        take(1),
        catchError(error => this.handleError(error)),
        tap(_ => {
          const index = this.model.documents.findIndex(el => el.id == document.id);
          this.model.documents.splice(index, 1);
          this.cdr.detectChanges();

        }),
      ).subscribe();
  }
}
